/**
 * BaseWidget Component - Salesforce SLDS Related List Style
 *
 * Базовый компонент для виджетов в стиле Salesforce Related Lists.
 * Белый фон, тонкая серая рамка, иконка слева от заголовка.
 */

import React, { useState } from 'react';
import {
  Paper,
  Group,
  Text,
  ActionIcon,
  Collapse,
  Box,
  Button,
  UnstyledButton
} from '@mantine/core';
import {
  IconChevronDown,
  IconChevronRight
} from '@tabler/icons-react';
import tokens from '../../../theme/designTokens';

const BaseWidget = ({
  title,
  icon: Icon,
  count,
  children,
  actions,
  onViewAll,
  defaultExpanded = true,
  collapsible = true
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Paper
      radius="xl"
      style={{
        overflow: 'hidden',
        border: `1px solid ${tokens.colors.neutral[3]}`,
        backgroundColor: tokens.colors.neutral.white,
      }}
    >
      {/* Заголовок виджета */}
      <UnstyledButton
        w="100%"
        onClick={() => collapsible && setExpanded(!expanded)}
        style={{
          cursor: collapsible ? 'pointer' : 'default',
        }}
      >
        <Group
          justify="space-between"
          px="md"
          py="sm"
          style={{
            borderBottom: expanded ? `1px solid ${tokens.colors.neutral[3]}` : 'none',
            minHeight: 64,
          }}
        >
          <Group gap="sm">
            {/* Иконка с цветным фоном */}
            {Icon && (
              <Box
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 4,
                  backgroundColor: tokens.colors.brand.primary,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon size={16} color="white" />
              </Box>
            )}

            <Text fw={600} size="sm" c={tokens.colors.neutral[9]}>
              {title}
              {count !== undefined && (
                <Text component="span" c={tokens.colors.neutral[7]} fw={400}>
                  {' '}({count})
                </Text>
              )}
            </Text>
          </Group>

          <Group gap="xs">
            {/* Кнопки действий */}
            {actions && (
              <Box onClick={(e) => e.stopPropagation()}>
                {actions}
              </Box>
            )}

            {/* Chevron для сворачивания */}
            {collapsible && (
              <ActionIcon variant="subtle" color="gray" size="sm">
                {expanded ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />}
              </ActionIcon>
            )}
          </Group>
        </Group>
      </UnstyledButton>

      {/* Контент */}
      <Collapse in={expanded}>
        <Box p="md">
          {children}
        </Box>

        {/* View All ссылка */}
        {onViewAll && (
          <Box
            py="xs"
            style={{
              borderTop: `1px solid ${tokens.colors.neutral[3]}`,
              textAlign: 'center',
            }}
          >
            <Button
              variant="subtle"
              size="xs"
              onClick={onViewAll}
              c={tokens.colors.brand.primary}
            >
              View All
            </Button>
          </Box>
        )}
      </Collapse>
    </Paper>
  );
};

export default BaseWidget;
